import { SelectProps } from "antd";
import SelectBaseAntd from "../SelectBaseAntd";
import { TipoAnexoContaEnum } from "core/features/conta/typings";

export interface SelectTipoAnexoContaProps<T = any> extends SelectProps<T> {
  value: any;
  onChange: (v: any) => void;
}

function SelectTipoAnexoConta({ value, ...rest }: SelectTipoAnexoContaProps) {
  const options = [
    {
      label: "Comprovante",
      value: TipoAnexoContaEnum.Comprovante,
    },
    {
      label: "Documento fiscal",
      value: TipoAnexoContaEnum.DocumentoFiscal,
    },
    {
      label: "Documento do pagamento",
      value: TipoAnexoContaEnum.DocumentoPagamento,
    },
    {
      label: "Documento acessório",
      value: TipoAnexoContaEnum.DocumentoAcessorio,
    },
    {
      label: "Outros",
      value: TipoAnexoContaEnum.Outros,
    },
  ];

  return (
    <SelectBaseAntd
      size="large"
      getPopupContainer={(node) => node.parentNode}
      placeholder="Selecione o tipo do anexo"
      value={value}
      defaultValue={null}
      options={options}
      {...rest}
    />
  );
}

export default SelectTipoAnexoConta;
